import React from 'react';
const editables = [{
  icon: '📋',
  number: 'E1',
  title: 'Planillas de Seguimiento Editables',
  desc: 'Fichas de control listas para personalizar con tu logo.'
}, {
  icon: '📊',
  number: 'E2',
  title: 'Tablas de Evaluación Nutricional',
  desc: 'Valoración clínica editable para cada tipo de paciente.'
}, {
  icon: '📝',
  number: 'E3',
  title: 'Plantillas de Informes para Médicos',
  desc: 'Informes profesionales editables para interdisciplina.'
}, {
  icon: '📅',
  number: 'E4',
  title: 'Planificador de Consultorio Mensual',
  desc: 'Organización semanal y mensual lista para usar.'
}, {
  icon: '🧾',
  number: 'E5',
  title: 'Modelos de Contratos y Consentimientos',
  desc: 'Documentación profesional para cubrir cada consulta.'
}, {
  icon: '💬',
  number: 'E6',
  title: 'Banco de Mensajes y Respuestas',
  desc: 'Plantillas de WhatsApp y email para cada situación.'
}];
export function Bonuses() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(236,252,203) 50%, rgb(240,253,244) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-66">
      <div className="mx-auto max-w-4xl" data-id="element-67">

        {/* Level Badge */}
        <div className="flex items-center justify-center mb-4" data-id="element-68">
          <span className="text-[10px] font-black text-white rounded-full px-3 py-1 tracking-wide" style={{
          backgroundImage: 'linear-gradient(135deg, rgb(77,124,15) 0%, rgb(101,163,13) 100%)'
        }} data-id="element-69">
            NIVEL 3
          </span>
        </div>

        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-70">
          🏆 Sistema Nutrición{' '}
          <span className="text-lime-600" data-id="element-71">Completa</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-72">
          Todo el Nivel 2 más 6 materiales editables para operar tu consultorio sin improvisar.
        </p>

        {/* Incluye niveles anteriores banner */}
        <div className="flex items-center gap-3 rounded-xl px-5 py-3 mb-6 shadow-sm" style={{
        backgroundColor: 'rgb(247,254,231)',
        border: '1px solid rgba(101,163,13,0.3)'
      }} data-id="element-73">
          <span className="text-lg shrink-0" data-id="element-74">✅</span>
          <div data-id="element-75">
            <p className="text-xs font-black text-lime-700 uppercase tracking-wide m-0" data-id="element-76">
              Megapack + Autoridad Nutricional incluidos
            </p>
            <p className="text-xs text-gray-500 font-medium m-0 mt-0.5" data-id="element-77">
              6 Tomos + 6 Bonos + 4 Tomos de Especialización ya adentro, más lo siguiente.
            </p>
          </div>
        </div>

        {/* Cards editables */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6" data-id="element-78">
          {editables.map(item => <div key={item.number} className="flex items-center gap-4 rounded-xl px-4 py-3" style={{
          backgroundColor: 'rgb(255,255,255)',
          border: '1px solid rgba(101,163,13,0.25)'
        }} data-id="element-79">
              <div className="shrink-0 w-12 h-12 rounded-xl flex items-center justify-center text-2xl" style={{
            backgroundImage: 'linear-gradient(135deg, rgba(77,124,15,0.08) 0%, rgba(101,163,13,0.18) 100%)'
          }} data-id="element-80">
                {item.icon}
              </div>
              <div className="flex-1 min-w-0" data-id="element-81">
                <p className="text-sm font-black text-gray-900 m-0 leading-tight" data-id="element-82">
                  {item.title}
                </p>
                <p className="text-[11px] text-gray-400 m-0 mt-0.5 leading-tight" data-id="element-83">
                  {item.desc}
                </p>
              </div>
              <span className="shrink-0 text-[10px] font-black text-white rounded-full px-2 py-0.5" style={{
            backgroundColor: 'rgb(77,124,15)'
          }} data-id="element-84">
                Editable
              </span>
            </div>)}
        </div>

{/* Footer bar */}
<div className="text-center rounded-xl px-5 py-5 shadow-sm" style={{
        backgroundImage: 'linear-gradient(135deg, rgba(77,124,15,0.06) 0%, rgba(101,163,13,0.12) 100%)',
        border: '1px solid rgba(101,163,13,0.25)'
      }} data-id="element-85">
  <p className="text-base font-black text-gray-900 m-0 mb-1" data-id="element-86">
    Tu consultorio, resuelto de principio a fin.
  </p>
  <p className="text-sm text-gray-500 m-0 mb-3" data-id="element-87">
    Todo lo clínico, todo lo operativo, todo lo editable. En un solo sistema.
  </p>
<div className="inline-block rounded-full px-6 py-2.5 cursor-pointer" style={{
          backgroundImage: 'linear-gradient(135deg, rgb(77,124,15) 0%, rgb(101,163,13) 100%)'
        }} onClick={() => {
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-88">
  <p className="text-sm font-black text-white m-0" data-id="element-89">
    🏆 QUIERO EL SISTEMA COMPLETO
  </p>
</div>
  <p className="text-[11px] text-gray-400 font-medium m-0 mt-3" data-id="element-90">
    Acceso inmediato · Todo editable · Sin improvisar nunca más.
  </p>
</div>

      </div>
    </section>;
}